import dayjs from "dayjs";
import { get } from "lodash";
import { useTranslation } from "react-i18next";
import {
  MdOutlineBadge,
  MdOutlineCake,
  MdOutlineHealthAndSafety,
} from "react-icons/md";
import Input from "shared/components/Input";
import Select from "shared/components/Select";
import { NAME_SPACES } from "shared/locales/constants";
import { DATE_FORMAT, GENDER, MILTIS_SOCIAL_REGIMES } from "utils/constants";
import { isMajor } from "utils/helpers/date";
import { bindDateInputProps, bindInputProps, bindTextFieldInputProps } from "utils/helpers/input";

export const step = { SPOUSE: "SPOUSE" };

const Spouse = ({
  index,
  translation,
  values,
  setFieldValue,
  ...formProps
}) => {
  const { t } = useTranslation(NAME_SPACES.PUBLIC.PROCESSES);
  const SOCIAL_REGIMES_TRANSLATION = t("B2C_MILTIS.SOCIAL_REGIMES", {
    returnObjects: true,
  });
  return (
    <div className="contact-stepper" key={step.SPOUSE}>
      <div className="contact-stepper__header--switch">
        <div className="contact-stepper__header">
          <div className="contact-stepper__header--counter">
            <span>{index}</span>
          </div>
          <div className="contact-stepper__header--content">
            <h1 className="contact-stepper__header--content--title">
              <span>
                {translation.TEMPLATES.CONTACT.STEPS[step.SPOUSE].TITLE}
              </span>
            </h1>
            <p className="contact-stepper__header--content--description">
              {translation.TEMPLATES.CONTACT.STEPS[step.SPOUSE].DESCRIPTION}
            </p>
          </div>
        </div>
        <Input
          type="switch"
          checkedChildren={
            translation.TEMPLATES.CONTACT.STEPS[step.SPOUSE].OPTIONS.YES
          }
          unCheckedChildren={
            translation.TEMPLATES.CONTACT.STEPS[step.SPOUSE].OPTIONS.NO
          }
          checked={get(values, "hasSpouse", false)}
          onChange={(e) => setFieldValue("hasSpouse", e)}
        />
      </div>
      {get(values, "hasSpouse", false) && (
        <div className="contact-stepper__content">
          <Input
            required
            label={
              translation.TEMPLATES.CONTACT.STEPS[step.SPOUSE].FORM.LASTNAME
                .LABEL
            }
            icon={<MdOutlineBadge size={22} />}
            placeholder={
              translation.TEMPLATES.CONTACT.STEPS[step.SPOUSE].FORM.LASTNAME
                .PLACEHOLDER
            }
            {...bindTextFieldInputProps({
              name: "spouse.identity.user.lastname",
              values,
              setFieldValue,
              ...formProps,
            })}
          />
          <Input
            required
            label={
              translation.TEMPLATES.CONTACT.STEPS[step.SPOUSE].FORM.FIRSTNAME
                .LABEL
            }
            icon={<MdOutlineBadge size={22} />}
            placeholder={
              translation.TEMPLATES.CONTACT.STEPS[step.SPOUSE].FORM.FIRSTNAME
                .PLACEHOLDER
            }
            {...bindTextFieldInputProps({
              name: "spouse.identity.user.firstname",
              values,
              setFieldValue,
              ...formProps,
            })}
          />
          <Input
            required
            icon={<MdOutlineCake size={22} />}
            label={
              translation.TEMPLATES.CONTACT.STEPS[step.SPOUSE].FORM.BIRTHDAY
                .LABEL
            }
            placeholder={
              translation.TEMPLATES.CONTACT.STEPS[step.SPOUSE].FORM.BIRTHDAY
                .PLACEHOLDER
            }
            format={DATE_FORMAT}
            type="date"
            variant="simple"
            disabledDate={(current) => current > isMajor}
            defaultPickerValue={
              !get(values, "spouse.identity.user.birthDate") &&
              dayjs().subtract(30, "years")
            }
            {...bindDateInputProps({
              name: "spouse.identity.user.birthDate",
              values,
              setFieldValue,
              ...formProps,
            })}
          />
          <Input
            type="radio"
            variant="group"
            required
            label={
              translation.TEMPLATES.CONTACT.STEPS[step.SPOUSE].FORM.SEXE.LABEL
            }
            values={[
              {
                label:
                  translation.TEMPLATES.CONTACT.STEPS[step.SPOUSE].FORM.SEXE
                    .MALE,
                value: GENDER.MALE,
              },
              {
                label:
                  translation.TEMPLATES.CONTACT.STEPS[step.SPOUSE].FORM.SEXE
                    .FEMALE,
                value: GENDER.FEMALE,
              },
            ]}
            icon={<MdOutlineBadge size={22} />}
            {...bindInputProps({
              name: "spouse.identity.user.gender",
              values,
              ...formProps,
            })}
          />
          <Select
            required
            icon={<MdOutlineHealthAndSafety size={22} />}
            options={Object.values(MILTIS_SOCIAL_REGIMES).map((option) => {
              const key = Object.keys(MILTIS_SOCIAL_REGIMES).find(
                (k) => MILTIS_SOCIAL_REGIMES[k] === option,
              );
              return {
                label: SOCIAL_REGIMES_TRANSLATION[key] || option,
                value: option,
              };
            })}
            label={
              translation.TEMPLATES.CONTACT.STEPS[step.SPOUSE].FORM.BASE_REGIME
                .LABEL
            }
            placeholder={
              translation.TEMPLATES.CONTACT.STEPS[step.SPOUSE].FORM.BASE_REGIME
                .PLACEHOLDER
            }
            {...bindInputProps({
              name: "spouse.identity.socialRegime",
              values,
              ...formProps,
            })}
          />
        </div>
      )}
    </div>
  );
};
export default Spouse;
